import React, { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from '../Onboarding.module.scss';
import gradientBG from '@app/img/onboarding/gradient_bg.png';

export default function Panel({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={cn(styles.panel, className)}>
      <div className={styles.clippedGradientBG}>
        <div className={cn(styles.bgImageContainer, styles.panelBgImageContainer)}>
          <img src={gradientBG} className={styles.bgImage} />
        </div>
      </div>
      {children}
    </div>
  );
}
